import { render, staticRenderFns } from "./langSwitcherFlag.vue?vue&type=template&id=1cd5dad8&scoped=true&lang=pug&"
import script from "./langSwitcherFlag.vue?vue&type=script&lang=ts&"
export * from "./langSwitcherFlag.vue?vue&type=script&lang=ts&"
import style0 from "./langSwitcherFlag.vue?vue&type=style&index=0&id=1cd5dad8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1cd5dad8",
  null
  
)

export default component.exports